const SERVICE_FEE = 200;

const getConsultationFeeWithService = (baseFee: number) =>
  baseFee + SERVICE_FEE;

const formatAmount = (originalValue: number) => {
  let formattedAmount: string = originalValue.toString();
  formattedAmount = originalValue.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formattedAmount;
};

export {formatAmount, SERVICE_FEE, getConsultationFeeWithService};
